import "./utils/initialize_highcharts"
import { appleSSO, facebookSSO, googleSSO } from "shared/sso"
import Success from "app/components/subscriptions/success"
import UpdatePaymentInfo from "app/components/subscriptions/update_payment_info/index"
import SetupActivityFeed from "app/scripts/setup_activity_feed"
import SetupUnifiedMobileMenu from "shared/scripts/setup_unified_mobile_menu"
import TFASendPin from "app/scripts/tfa_send_pin"
import AdminLayover from "app/scripts/admin_layover"
import SetupDeleteAccountSurvey from "app/scripts/setup_delete_account_survey"
import HandleVerifyDeleteAccountByEmail from "app/scripts/handle_verify_delete_account_by_email"

import ServiceSearch from "app/components/service_search"
import onReCAPTCHASuccess from "shared/verify_recaptcha"
import AlreadySignedInPage from "app/components/sdk/already_signed_in_page"
import ConfigurePage from "app/components/sdk/configure_page"
import ConnectedServicePage from "app/components/sdk/connected_service_page"
import FlowUrlConstructor from "app/components/sdk/flow_url_constructor"
import LandingPage from "app/components/sdk/landing_page"
import RefreshFormAuthenticityToken from "app/scripts/refresh_form_authenticity_token"
import ResetPasswordPage from "app/components/sdk/reset_password_page"
import SignInPage from "app/components/sdk/sign_in_page"
import SignUpPage from "app/components/sdk/sign_up_page"
import UnifiedProfileDropdown from "shared/components/unified_profile_dropdown"
import ErrorSuccessHistogramChart from "shared/components/error_success_histogram_chart"
import PerformanceTriggerActionChart from "shared/components/performance_trigger_action_chart"

// Generic Helper components
import GrowingTextArea from "shared/growing_text_area"
import LimitedTextInput from "shared/limited_text_input"

// Page Specific Components
import ActivitySteps from "app/components/activity_steps"
import SLAPrompt from "shared/components/sla_prompt"
import ProDetailsPopup from "shared/components/pro_details_popup"

// Stored Fields
import CheckBoxesField from "shared/components/stored_fields/check_boxes_field/index"
import SelectField from "shared/components/stored_fields/select_field/index"
import LocationField from "shared/components/stored_fields/location_field/index"
import DoubleSelectField from "shared/components/stored_fields/double_select_field/index"
import IngredientTextField from "shared/components/stored_fields/ingredient_text_field/index"
import TimeOfDayField from "shared/components/stored_fields/time_of_day_field"
import MinutesPastHourField from "shared/components/stored_fields/minutes_past_hour_field"
import DateAndTimeField from "shared/components/stored_fields/date_and_time_field"
import PlatformSuggestion from "app/components/platform_feedback/platform_suggestion"

// Connect
import Container from "app/components/connect_url"
import ConnectSDKAppletConfig from "app/components/connect_sdk_applet/config"

import ServiceCard from "shared/components/service_card"
import ConnectionCard from "shared/components/connection_card"
import ConnectButton from "shared/components/connection_card/connect_button"
import ConnectionConfig from "shared/components/connection_card/config"
import SettingsButton from "shared/components/connection_card/settings_button"
import AuthorInfo from "shared/components/connection_card/author_info"
import ConnectionCardTitle from "shared/components/connection_card/title"
import ReturningUserFlow from "app/components/connect_sdk_applet/returning_user_flow"
import TransitionAndRedirect from "app/components/connect_sdk_applet/returning_user_flow/transition_and_redirect"
import appletOrConnectionPath from "app/scripts/applet_or_connection_path"

// IFTTT Next
import ConnectView from "app/components/ifttt_next/connect/index"
import MyServiceSettingsView from "app/components/ifttt_next/services/my_service_settings_view/index"
import GetMore from "app/components/ifttt_next/get_more/index"
import Profile from "app/components/ifttt_next/profile/index"
import IFTTTNextStory from "app/components/ifttt_next/stories/index"
import { MyServiceView } from "app/components/ifttt_next/services/my_service_view"
import { DiscoverServiceView } from "app/components/ifttt_next/services/discover_service_view"
import TQAHeader from "app/components/ifttt_next/services/tqa/header"
import TQAInfo from "app/components/ifttt_next/services/tqa/info"
import LearnMoreButton from "shared/components/learn_more_button"
import SmallAppletCard from "shared/components/applet_card/ifttt_next/small_applet_card"
import MyApplets from "app/components/ifttt_next/my_applets/index"
import ArchiveApplets from "app/components/ifttt_next/archive/index"
import MyServices from "app/components/ifttt_next/my_services/index"

import DIY from "app/components/diy_composer"
import OnboardingRecommendations from "app/components/onboarding_recommendations"

import BillingSwitchPlanLink from "app/components/billing/switch_plan/index.tsx"
import BillingCancelContainer from "app/components/billing/cancel/index.tsx"
import PromotionContainer from "app/components/billing/cancel/promotion/index.tsx"
import ReferralCode from "app/components/referral/index.tsx"
import Rewards from "app/components/referral/rewards/index.tsx"
import ReceiptSettings from "app/components/billing/receipt_settings"

import FeatureToggleManagement from "app/components/feature_toggle_management"
import FeedbackPrompt from "app/components/feedback_prompt/index.tsx"

window.App.storedFieldPath = (resolveUrl, liveChannelId = "") =>
  `/stored_fields/options?resolve_url=${resolveUrl}&live_channel_id=${liveChannelId}`

Object.assign(window.App.Comps, {
  // React components
  ActivitySteps,
  ArchiveApplets,
  BillingCancelContainer,
  PromotionContainer,
  ReferralCode,
  Rewards,
  BillingSwitchPlanLink,
  CheckBoxesField,
  ConnectView,
  DIY,
  DateAndTimeField,
  DiscoverServiceView,
  DoubleSelectField,
  FeedbackPrompt,
  GetMore,
  GrowingTextArea,
  IFTTTNextStory,
  IngredientTextField,
  LearnMoreButton,
  LimitedTextInput,
  LocationField,
  MinutesPastHourField,
  MyApplets,
  MyServiceSettingsView,
  MyServiceView,
  MyServices,
  OnboardingRecommendations,
  PlatformSuggestion,
  ProDetailsPopup,
  Profile,
  ReceiptSettings,
  SLAPrompt,
  SelectField,
  ServiceCard,
  ServiceSearch,
  SmallAppletCard,
  TQAHeader,
  TQAInfo,
  TimeOfDayField,
  UnifiedProfileDropdown,
  Subscriptions: {
    Success,
    UpdatePaymentInfo,
  },
  Sdk: {
    AlreadySignedInPage,
    ConfigurePage,
    ConnectedServicePage,
    FlowUrlConstructor,
    LandingPage,
    ResetPasswordPage,
    SignInPage,
    SignUpPage,
  },
  Access: {
    ConnectSDKAppletConfig,
    ReturningUserFlow,
    TransitionAndRedirect,
  },
  ConnectionCard: {
    ConnectionCard,
    ConnectButton,
    ConnectionConfig,
    SettingsButton,
    AuthorInfo,
    Title: ConnectionCardTitle,
  },
  ConnectURL: {
    Container,
  },
  FeatureToggleManagement,
  ErrorSuccessHistogramChart,
  PerformanceTriggerActionChart,
})

// Per-page functions to setup non-react behavior (ex. standard jQuery code)
Object.assign(window.App.Scripts, {
  SetupActivityFeed,
  SetupUnifiedMobileMenu,
  TFASendPin,
  AdminLayover,
  appleSSO,
  googleSSO,
  facebookSSO,
  onReCAPTCHASuccess,
  SetupDeleteAccountSurvey,
  appletOrConnectionPath,
  RefreshFormAuthenticityToken,
  HandleVerifyDeleteAccountByEmail,
})
